import React, { useEffect, useState } from "react";
import {
  GalleryCard,
  GallerySectionContainer,
  HighlightContainer,
  HighlightInnerContainer,
  HomeContainer,
  JadwalKlasemenContainer,
  NewsSectionContainer,
  SectionContainer,
  SwooshSVG,
  FloatingIcon,
  LottieFloatingIcon,
  FloatingIconWrapper,
  BigNewsCard,
  ContainerWidth,
  HighlightContainerOuter,
  OuterNewsContainer,
  SliderContainer,
  InnerContainer,
  TimelineLabel,
} from "./HomeUser.styled";

import HomeHighlightCard from "../HomeDetails/HighlightCard";
import HomeNewsCard from "../HomeDetails/NewsCard";
import BigHomeNewsCard from "../HomeDetails/BigNewsCard";
import HomeGalleryCard from "../HomeDetails/GalleryCard";
import SliderWrapper from "../../../components/atoms/SliderWrapper";

import BannerCity from "../../../components/molecules/v2/BannerCity";
import Section from "../../../components/atoms/Section";
import {
  usePageContextFunction,
  usePageContextState,
} from "../../../context/PageContext";
import {
  useFetchEventDetail,
  useFetchGalleryArticle,
  useFetchHighlightArticle,
  useFetchWhatNew,
  useFetchSection,
  useFetchTimelineSeries,
  useFetchCurrentRegistrationData,
  useFetchRegionEventSeries,
} from "../../../networks";
import { useNavigate, useParams } from "react-router-dom";
import { func } from "../../../utils";
import { NewFooter, Spacer } from "../../../components";
import analytics from "../../../utils/analytics";
import { capitalizeFLetter } from "../../../utils/function";
import moment from "moment";
import Announce from "../../../components/atoms/Announce";
import Sponsor from "../../../components/atoms/Sponsor";
import useWindowSize from "../../../hooks/useWindowSize";
import Lottie from "react-lottie";
import * as animationData from "../../../assets/animation/floatingIcon.json";
import HallOfFameCard from "../HomeDetails/HallOfFameCard";
import { Container } from "../Home/Home.styled";
import useHideStatisticAndHallOfFame from "../../../hooks/useHideStatisticAndHallOfFame";
import TimelinePathScroll from "../../../components/molecules/v2/TimelinePathScroll";
import BannerCityUser from "../../../components/molecules/v2/BannerCityUser";
import Sidebar from "../../../components/molecules/Sidebar";
import {
  useCitySchool,
  useSchoolCategory,
  useUserData,
} from "../../../store/user";

const HomeUser = ({ slug }) => {
  const {
    setOpenPopUp: toglePopUp,
    setPageMode,
    setCity,
    setIsLive,
    setVideoUrl,
    setIsRegist,
    setRegistrationUrl,
  } = usePageContextFunction();

  const { idInView } = usePageContextState();

  const { size } = useWindowSize();

  useEffect(() => {
    setPageMode("home-details");
  }, []);
  const { city } = useParams();

  const { accessToken, setRegistrationData, registrationData } = useUserData();
  const { setCitySchool } = useCitySchool();
  const { setSchoolCategory, schoolCategory } = useSchoolCategory();
  const { data: dataRaw, isFetching: fetchingEventRegion } =
    useFetchRegionEventSeries();

  const dataRegistCity = dataRaw?.data?.data?.eventSeries || [];
  const dataCityUser = dataRegistCity?.find(
    (val) => val?.id === registrationData?.region_id
  );

  const slugCity = dataCityUser?.slug;
  const { data: dataHighlightArticle, isFetching: fetchingHighlightArticle } =
    useFetchHighlightArticle(slugCity, !fetchingEventRegion);
  const { data: dataGalleryArticle } = useFetchGalleryArticle(
    slugCity,
    !fetchingEventRegion
  );
  const { data: dataWhatsNewArticle } = useFetchWhatNew(
    slugCity,
    !fetchingEventRegion
  );

  const dataHighlight = dataHighlightArticle?.data?.data;
  const dataGalleryRaw = dataGalleryArticle?.data?.data ?? [];

  const { data: registrationDataRaw, isFetching } =
    useFetchCurrentRegistrationData(!fetchingEventRegion);
  const { data: dataTimeline, refetch: refetchTimeline } =
    useFetchTimelineSeries(slugCity, false);
  const { data: dataEventDetail, refetch: refetchEventDetail } =
    useFetchEventDetail(slugCity, false);
  useEffect(() => {
    if (!isFetching) {
      const apiSchoolCategory =
        registrationDataRaw?.data?.data?.registration?.school_category;
      console.log({ apiSchoolCategory });
      const citySchool = dataCityUser?.region_name;

      // Update registration data from API
      setRegistrationData({
        ...registrationDataRaw?.data?.data?.registration,
        region_name: dataCityUser?.region_name,
      });

      // Only set the school category if:
      // 1. Current schoolCategory is empty (user hasn't selected one yet)
      // 2. OR we have valid API data that should override the selection

      if (!schoolCategory || (apiSchoolCategory && registrationData?.id)) {
        setSchoolCategory(apiSchoolCategory);
      }

      setCitySchool({ ...dataCityUser, cardDate });

      if (slugCity) {
        refetchTimeline();
        refetchEventDetail();
      }
    }
  }, [isFetching, slugCity]);
  const dataWhatsNew = dataWhatsNewArticle?.data?.data ?? [];

  const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/featured-images/`;

  const isLoading = fetchingHighlightArticle;

  const isMobileView = (size?.width || 0) <= 830;

  const dataEvent = dataEventDetail?.data?.data?.eventDetail ?? {};
  const navigate = useNavigate();

  const [isShowFloating, setIsShowFloating] = useState(true);
  const [navbarShow, setNavbarShow] = useState(false);

  const { data: dataSectionRaw } = useFetchSection();

  const dataSection = dataSectionRaw?.data?.data?.sections ?? [];

  const { event_start_date, event_end_date, video_url, registration_url } =
    dataEvent;

  const startDate = moment(event_start_date);
  const endDate = moment(event_end_date);
  const isSameMonthEvent = startDate.format("MMMM") === endDate.format("MMMM");
  const isSameDate = startDate.format("D") === endDate.format("D");
  const cardDate = isSameMonthEvent
    ? isSameDate
      ? `${endDate?.format("D MMMM YYYY")}`
      : `${startDate?.format("D")} - ${endDate?.format("D MMMM YYYY")}`
    : `${startDate?.format("D MMMM")} - ${endDate?.format("D MMMM YYYY")}`;
  const isShowFloat = React.useMemo(() => {
    return isShowFloating && !idInView?.includes("footer") && !navbarShow;
  }, [navbarShow, isShowFloating]);

  const liveStreaming = React.useMemo(() => {
    const currentDate = moment();
    if (
      !!video_url &&
      currentDate.isSameOrAfter(startDate, "day") &&
      currentDate.isSameOrBefore(endDate, "day")
    ) {
      setIsLive(true);
      setVideoUrl(video_url);
      return {
        isLive: true,
      };
    }

    setIsLive(false);
    setVideoUrl("");
    return { isLive: false };
  }, [video_url]);

  const handleShowFloatingIcon = () => {
    setIsShowFloating(true);
  };
  const handleHideFloatingIcon = () => {
    setIsShowFloating(false);
  };

  useEffect(() => {
    analytics.sendEvent({
      event: "pialabyu_cityLP",
      city: capitalizeFLetter(slugCity),
    });

    setCity(slugCity);
    setVideoUrl(video_url);
  }, [slugCity, liveStreaming?.isLive]);

  useEffect(() => {
    let timeout;

    const handleScroll = () => {
      setIsShowFloating(false);

      clearTimeout(timeout);
      timeout = setTimeout(() => {
        setIsShowFloating(true);
      }, 200); // Adjust the timeout value as needed
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(timeout);
    };
  }, []);

  const handleClickNavbar = (e) => {
    const className = String(e.target.className);

    if (className?.includes("navbar")) {
      setNavbarShow(className?.includes("onOpen"));
      handleHideFloatingIcon();
    }
  };

  const _renderNewsMobileView = (data) => {
    return data?.map((value, idx) => (
      <HomeNewsCard
        key={idx}
        title={value?.title}
        subTitle={value?.subtitle}
        imgSrc={
          isMobileView
            ? imgPath + value?.key_visual_mobile
            : imgPath + value?.key_visual
        }
        mobileView={isMobileView}
        onClick={() => {
          toglePopUp({
            state: true,
            data: value,
            currentCity: slugCity,
          });
        }}
      />
    ));
  };

  const _renderNewsDesktopView = (data) => {
    return data?.map((value, idx) => (
      <>
        <HomeNewsCard
          key={idx}
          title={value?.title}
          subTitle={value?.subtitle}
          imgSrc={
            isMobileView
              ? imgPath + value?.key_visual_mobile
              : imgPath + value?.key_visual
          }
          mobileView={isMobileView}
          onClick={() => {
            toglePopUp({
              state: true,
              data: value,
              currentCity: slugCity,
            });
          }}
        />
      </>
    ));
  };

  /* Listen to navbar clicked */
  useEffect(() => {
    window.addEventListener("click", handleClickNavbar);

    return () => {
      window.removeEventListener("click", handleClickNavbar);
    };
  }, []);
  const isLogin = !!accessToken;
  return (
    <div className="flex w-full">
      {isLogin && !isMobileView && <Sidebar />}
      <div
        style={{ overflowX: "hidden" }}
        className={"md:mr-[20px] md:w-[75vw] w-full mr-[0px]"}
      >
        {!isLogin ? (
          <Section id="home-detail-banner" height={"auto"}>
            <BannerCity
              data={dataEvent}
              slug={slugCity}
              isLive={liveStreaming?.isLive}
            ></BannerCity>
          </Section>
        ) : (
          <Section id="home-banner-user" height={"auto"}>
            <BannerCityUser
              data={{
                ...dataTimeline?.data?.data?.timeline[
                  dataTimeline?.data?.data?.timeline?.length - 1
                ],
                ...dataCityUser,
                ...dataEvent,
                cardDate,
                ...registrationData,
              }}
            />
          </Section>
        )}

        <HomeContainer>
          {dataTimeline?.data?.data?.timeline?.length ? (
            <Section
              id="timeline"
              height={"auto"}
              backgroundColor={"transparent"}
              className={"md:!justify-start md:ml-6"}
            >
              <ContainerWidth>
                <SectionContainer paddingRight="0px" paddingLeft="0px">
                  {isMobileView ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <h5
                        style={{
                          textAlign: "left",
                          marginTop: 24,
                          marginLeft: 16,
                        }}
                      >
                        Timeline
                      </h5>
                      <div
                        style={{
                          marginTop: 24,
                          cursor: "pointer",
                          marginRight: 24,
                        }}
                        onClick={() => {
                          toglePopUp({
                            state: true,
                            data: dataTimeline?.data?.data?.timeline || [],
                            currentCity: slugCity,
                            typePopUp: "timeline",
                          });
                        }}
                      >
                        <span
                          className="flex items-center flex-row whitespace-nowra gap-1"
                          style={{
                            fontSize: 12,
                            color: "#0397C9",
                            fontWeight: "bold",
                          }}
                        >
                          Lihat Jadwal
                          <img
                            src={func.getStaticImg("/icon/right-arrow.svg")}
                            style={{ marginLeft: 2 }}
                          ></img>
                        </span>
                      </div>
                    </div>
                  ) : (
                    <TimelineLabel>Timeline</TimelineLabel>
                  )}
                  <TimelinePathScroll
                    data={dataTimeline?.data?.data?.timeline || []}
                  />
                </SectionContainer>
              </ContainerWidth>
            </Section>
          ) : (
            <></>
          )}

          {dataWhatsNew?.length !== 0 && (
            <Section
              id="home-detail-content-01"
              height={"auto"}
              className={"!justify-start md:ml-6"}
            >
              <ContainerWidth>
                <SectionContainer paddingRight="0px">
                  {isMobileView ? (
                    <h5
                      style={{ width: "100%", textAlign: "left", margin: "0" }}
                    >
                      Berita Terbaru
                    </h5>
                  ) : (
                    <h3
                      style={{ width: "100%", textAlign: "left", margin: "0" }}
                    >
                      Berita Terbaru
                    </h3>
                  )}
                  <OuterNewsContainer>
                    <NewsSectionContainer>
                      {isMobileView
                        ? _renderNewsMobileView(dataWhatsNew)
                        : _renderNewsDesktopView(dataWhatsNew)}
                    </NewsSectionContainer>
                  </OuterNewsContainer>
                </SectionContainer>
              </ContainerWidth>
            </Section>
          )}
        </HomeContainer>
      </div>
    </div>
  );
};

const styles = {
  onHide: {
    opacity: 0,
  },
  onShow: {
    opacity: 1,
    transition: "opacity 0.2s linear",
  },
};

export default HomeUser;
